import {
  Create,
  NumberInput,
  RecordField,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "@/components/admin"
import { RaRecord } from "ra-core"
import { ReactElement } from "react"
import StoreyCard from "../../components/storey-card"

const StoreysEdit = (): ReactElement => {
  const pid = localStorage.getItem("pid")

  return (
    <Create
      className="py-6"
      title={null}
      transform={(data: RaRecord) => {
        const payload = {
          ...data,
          project_id: pid,
        }
        localStorage.removeItem("pid")
        return payload
      }}
      redirect={`/projects/${pid}/edit`}
    >
      <SimpleForm>
        <StoreyCard
          open
          title="Créer un étage"
          level={<RecordField source="level" label="" />}
          rooms={<RecordField source="rooms" label="" />}
          bathrooms={<RecordField source="bathrooms" label="" />}
          wcs={<RecordField source="wcs" label="" />}
        >
          <div className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-6 xs:grid-cols-6 gap-4 pb-4">
            <TextInput source="title" />
            <TextInput source="description" />
            <NumberInput source="level" />
            <NumberInput source="surface" />
            <NumberInput source="rooms" />
            <NumberInput source="bathrooms" />
            <NumberInput source="wcs" />
            <ReferenceInput reference="project_phases" source="status">
              <SelectInput />
            </ReferenceInput>
          </div>
        </StoreyCard>
      </SimpleForm>
    </Create>
  )
}

export default StoreysEdit
